import React from "react";
import Aboutus1 from "../components/Aboutus/Aboutus1";
// import ClientCarousel from "../components/landingpage/ClientCarousel";
// import data from "../json/Aboutus/Clientcarousel.json";
import Leadership from "../components/Aboutus/Leadership";
import Journey from "../components/Aboutus/Journey";
// import Testimonial from "../components/landingpage/Testimonial";
import Testimonialnew from "../components/landingpage/Testimonialnew";
import Section4 from "../components/Allcontent/Section4";
import data from '../json/Aboutus/Aboutus1.json'
import Aboutus2 from "../components/Aboutus/Aboutus2";
import parse from "html-react-parser"
const Aboutus = () => {
  return (
    <div className="w-full flex flex-col items-center ruler ">
      <Aboutus1 data={data} />
      <Aboutus2 data={data.section1} />
      <div className="2xl:container md:px-20 px-6 pt-16 pb-8 md:pt-20 md:pb-16 w-full flex justify-center">
        <h4 className="text-24 md:text-48 text-primarycolor font-semibold md:w-[90%] sm:w-[80%] w-full text-center">{parse(data.section2.maintitle)}</h4>
      </div>
      <Section4 data={data.section2} />
      <Journey />

      <Leadership />
      <Testimonialnew />
    </div>
  );
};

export default Aboutus;
